<template>
  <div ref="metricKpiActualForm">
    <div v-if="nbOfErrors > 0" class="bs3-margin-bottom30">
      <div class="row">
        <div class="col-xs-12">
          <div class="text-center">
            <span class="h5 label label-danger">{{ nbOfErrors | error(pDictionary) }}</span>
          </div>
        </div>
      </div>
    </div>
    <p class="lead">{{ 'dictionary.media.insertion.metric.kpi.actual.cmd.update.description' | i18nText(pDictionary) }}</p>
    <ul class="list-unstyled">
      <li class="bs3-margin-bottom30">
        <h4>{{ 'dictionary.media.insertion.metric.kpi.actual.cmd.update.step1'  | i18nText(pDictionary) }}</h4>
        <p v-html="pDictionary['dictionary.media.insertion.metric.kpi.actual.cmd.update.step1.description']"></p>
        <div>
          <div class="btn-group bs3-margin-bottom7" role="group" aria-label="Display timeline by">
            <input type="hidden" :name="'bulkCmdDataForm.mediaInsertionRef.id'"
                   :value="pDataForm.mediaInsertionRef.id"/>
            <input type="hidden" name="bulkCmdDataForm.calendarTimeline"
                   v-model="calendarTimeline"/>

            <a ref="calendarTimelineDay"
               :class="['btn btn-sm', isTimelineByActive('DAY') ? 'btn-primary active': 'btn-default']"
               @click.prevent="onTimelineChange('DAY')">{{ 'dictionary.general.date.day' | i18nText(pDictionary) }}
            </a>
            <a ref="calendarTimelineWeek"
               :class="['btn btn-sm', isTimelineByActive('WEEK') ? 'btn-primary active': 'btn-default']"
               @click.prevent="onTimelineChange('WEEK')">{{ 'dictionary.general.date.week' | i18nText(pDictionary) }}
            </a>
            <a ref="calendarTimelineMonth"
               :class="['btn btn-sm', isTimelineByActive('MONTH') ? 'btn-primary active': 'btn-default']"
               @click.prevent="onTimelineChange('MONTH')">{{ 'dictionary.general.date.month' | i18nText(pDictionary) }}
            </a>
            <a ref="calendarTimelineQuarter"
               :class="['btn btn-sm', isTimelineByActive('QUARTER') ? 'btn-primary active': 'btn-default']"
               @click.prevent="onTimelineChange('QUARTER')">{{ 'dictionary.general.date.quarter' | i18nText(pDictionary) }}
            </a>
            <a ref="calendarTimelineYear"
               :class="['btn btn-sm', isTimelineByActive('YEAR') ? 'btn-primary active': 'btn-default']"
               @click.prevent="onTimelineChange('YEAR')">{{ 'dictionary.general.date.year' | i18nText(pDictionary) }}
            </a>
          </div>

          <confirmation-alert
              ref="timelineChangeConfirmationAlert"
              :p-text-html="'dictionary.media.insertion.metric.kpi.actual.cmd.update.timeline.change.confirmation.html' | i18nText(pDictionary)"
              :p-cancel-button-text="'dictionary.actions.no' | i18nText(pDictionary)"
              :p-confirm-button-text="'dictionary.actions.yes' | i18nText(pDictionary)"></confirmation-alert>
        </div>
      </li>
      <li>
        <h4>{{'dictionary.media.insertion.metric.kpi.actual.cmd.update.step2' | i18nText(pDictionary)}}</h4>
        <p v-html="pDictionary['dictionary.media.insertion.metric.kpi.actual.cmd.update.step2.description']"></p>

        <div class="well well-sm">
          <strong>{{ 'dictionary.currency' | i18nText(pDictionary) }}</strong>: {{pDataForm.currencyRef.name}}
        </div>

        <div class="table-responsive">
          <metric-kpi-actual-form-table
              :p-currencies="pCurrencies"
              :p-language="pLanguage"
              :p-dictionary="pDictionary"
              :p-currency-ref="pDataForm.currencyRef"
              :p-kpi-cost-for-activated="pDataForm.kpiCostForActivated"
              :p-kpi-field-activation-rules="pDataForm.kpiFieldActivationRules"
              :p-kpi-actual-list="kpiActualList"
              :p-error-list="pErrorList"></metric-kpi-actual-form-table>
        </div>
      </li>
      <li>
        <h4>{{'dictionary.media.insertion.metric.kpi.actual.cmd.update.step3' | i18nText(pDictionary)}}</h4>
        <p v-html="pDictionary['dictionary.media.insertion.metric.kpi.actual.cmd.update.step3.description']"></p>
      </li>
    </ul>
  </div>
</template>

<script>
import MetricKpiActualFormTable from "@/components/common/metric/kpi/actual/form/MetricKpiActualFormTable";
import ConfirmationAlert from "@/components/ui/ConfirmationAlert";
import FormatMixin from "@/mixins/format-mixin";

export default {
  name: "MetricKpiActualForm",
  mixins: [FormatMixin],
  components: {ConfirmationAlert, MetricKpiActualFormTable},
  props: {
    pCurrencies: Array,
    pLanguage: String,
    pDictionary: Object,
    pSrc: {
      type: String,
      default: function () {
        return ''
      }
    },
    pSrcId: {
      type: String,
      default: function () {
        return ''
      }
    },
    pErrorList: Object,
    pDataForm: Object,
  },
  data: function () {
    return {
      kpiActualList: this.pDataForm.kpiActualList,
      calendarTimeline: this.pDataForm.calendarTimeline
    }
  },
  methods: {
    isTimelineByActive(calendarTimeline)
    {
      return this.calendarTimeline === calendarTimeline;
    },
    async onTimelineChange(calendarTimeline)
    {
      const confirmed = await this.$refs.timelineChangeConfirmationAlert.show();
      if(confirmed)
      {
        this.calendarTimeline = calendarTimeline;
        this.refreshKpiActuals();
      }
    },
    refreshKpiActuals()
    {
      let _component = this;
      $.ajax({
               type: "POST",
               url: "/mediaplan/app/endpoints/json-api/metric/kpi/actual/refresh-timeline",
               data: JSON.stringify({
                                      "mediaInsertionRef": _component.pDataForm.mediaInsertionRef,
                                      "kpiActualList": _component.kpiActualList,
                                      "calendarTimeline": _component.calendarTimeline
                                    }),
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
             }).done(function (kpiActualList) {
        _component.kpiActualList = kpiActualList;
      });
    }
  },
  computed: {
    nbOfErrors: function () {
      return Object.keys(this.pErrorList).length;
    }
  },
  mounted: function () {
    const _component = this;
    const $metricKpiActualForm = $(_component.$refs.metricKpiActualForm);
    $metricKpiActualForm.find('[data-toggle="tooltip"]').tooltip({container: 'body', sanitize: false});
  },
  destroy: function () {
    const _component = this;
    const $metricKpiActualForm = $(_component.$refs.metricKpiActualForm);
    $metricKpiActualForm.find('[data-toggle="tooltip"]').tooltip('destroy');
  }
}
</script>

<style scoped>

</style>